import { useRef, useState } from 'react'

// Note: call `check` on hover (layout is only measurable then) and read `isTruncated`
// to enable a tooltip. `lines` > 1 measures a line-clamped box instead of a single line.
export const useIsTruncated = <T extends HTMLElement>(lines = 1) => {
  const ref = useRef<T>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  const check = () => {
    const element = ref.current
    if (!element) return
    setIsTruncated(
      lines > 1
        ? element.scrollHeight > element.clientHeight
        : element.scrollWidth > element.clientWidth,
    )
  }

  return { check, isTruncated, ref }
}
